import Icon from '../../../components/AppIcon';
import { toArabicDigits } from '../../../utils/numbers';

const ClapSystem = ({ totalClaps, hasClapped, onClap, loading, isAuthenticated }) => {
  const handleClick = () => {
    if (!isAuthenticated || loading) return;
    onClap?.();
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <button
        onClick={handleClick}
        disabled={loading || !isAuthenticated}
        className="flex flex-col items-center gap-2 p-4 rounded-full transition-all duration-300 hover:scale-105 disabled:opacity-60 disabled:cursor-not-allowed"
        style={{
          backgroundColor: hasClapped ? 'rgba(197, 160, 89, 0.2)' : 'rgba(197, 160, 89, 0.1)',
          border: '2px solid #C5A059'
        }}
        aria-label={hasClapped ? 'إلغاء الإعجاب' : 'إعجاب'}
      >
        <Icon
          name={hasClapped ? 'HeartOff' : 'Heart'}
          size={32}
          color="#C5A059"
          fill={hasClapped ? '#C5A059' : 'none'}
        />
      </button>

      <div className="mt-6 text-center">
        <p
          className="text-4xl font-bold mb-2"
          style={{
            fontFamily: 'Aref Ruqaa, serif',
            color: '#C5A059'
          }}
        >
          {toArabicDigits(totalClaps ?? 0)}
        </p>
        <p
          className="text-base"
          style={{
            fontFamily: 'Amiri, serif',
            color: '#5A5A5A'
          }}
        >
          إعجاب من القراء
        </p>
      </div>
    </div>
  );
};

export default ClapSystem;
